import type { NotificationPlan } from '@autoday/core';

export type ChannelKind = 'android-local' | 'ios-local' | 'web-push' | 'none';

export type ActionNeeded =
  | 'request-permission'
  | 'open-app-settings'
  | 'enable-exact-alarms'
  | 'connect-account'
  | 'subscribe-push'
  | 'install-pwa';

export interface ChannelStatus {
  channel: ChannelKind;
  label: string;
  permission: 'granted' | 'denied' | 'prompt' | 'unsupported';
  exactAlarms: 'granted' | 'denied' | 'n/a';
  /** Kan kanalen leverera när appen är stängd? */
  backgroundCapable: boolean;
  /** Ärliga begränsningar i klartext. */
  limitations: string[];
  actions: Array<{ id: ActionNeeded; label: string }>;
}

export interface ScheduleReport {
  at: string;
  channel: ChannelKind;
  requested: number;
  /** ID:n som transporten accepterade. Accepterat ≠ visat. */
  accepted: string[];
  /** Antal som faktiskt låg i plattformens pending-lista vid kontroll (null = går ej att kontrollera). */
  verifiedPending: number | null;
  /** Schemalagda som inexakta (Android utan exakt-larm-tillstånd). */
  inexact: boolean;
  errors: string[];
  coverageUntil: string | null;
  overflowPoints: number;
}

/** Fysiskt ljud/vibration styrs per lokal profil på den här enheten, inte via kontosynk. */
export interface NotificationOutput {
  sound: boolean;
  vibration: boolean;
}

export const DEFAULT_NOTIFICATION_OUTPUT: NotificationOutput = { sound: true, vibration: true };

export interface NotificationTransport {
  readonly channel: ChannelKind;
  /** Max antal samtidigt schemalagda notiser vi använder på kanalen. */
  readonly capacity: number;
  status(): Promise<ChannelStatus>;
  requestPermission(): Promise<ChannelStatus>;
  /** Synkar plattformens schemaläggning mot planen (avbokar inaktuella, lägger till nya, verifierar). */
  apply(plan: NotificationPlan, opts: { hideSensitive: boolean; output?: NotificationOutput; activeTestId?: number }): Promise<ScheduleReport>;
  /** "Testa om 1 minut" – via SAMMA transport som ordinarie notiser. */
  scheduleTest(fireAt: Date, testId: string, output?: NotificationOutput): Promise<{ ok: boolean; detail: string }>;
  openSettings?(id: ActionNeeded): Promise<void>;
}
